exports = module.exports = require("../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1E376F"}}!./~/antd/lib/locale-provider/style/index.less
// module id = 1417
// module chunks = 0